<template>
  <div>
    <div class="block-wrap flex-column">
      <div class="block-title">门店管理员账号信息</div>
      <div class="block-code-wrap flex-row-center">
        <p class="label"><em>*</em>注册手机</p>
        <div class="block-right">
          <el-input v-model="chainPhone" placeholder="请输入手机号码">
          </el-input>
        </div>
      </div>
      <div class="block-code-wrap flex-row-center">
        <p class="label"><em>*</em>验证码</p>
        <div class="block-right flex-row">
          <el-input v-model="smsCode" placeholder="请输入验证码" class="block-input">
          </el-input>
          <el-button type="primary" class="block-btn" :disabled="flag" @click="chainSmsCode">{{ flag ? `${count}s`:'验证码' }}</el-button>
        </div>
      </div>
      <div class="block-next flex-row-center">
        <el-button type="primary" class="btn-next" @click="chainShopCreate">保存，进入下一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { chainShopCreate, chainSmsCode } from '@/api/merchant-info'
export default {
  props: {
    activeCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      chainPhone: '',
      smsCode: '',
      flag: false,
      count: 60
    }
  },
  methods: {
    // 短信
    async chainSmsCode () {
      if (this.flag) return
      if (!this.chainPhone) {
        this.$message.error('请输入手机号码')
        return
      }
      var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/
      var result = re.test(this.chainPhone)
      if (!result) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      try {
        const res = await chainSmsCode({
          chainPhone: this.chainPhone
        })
        if (res.error_code !== '0') {
          this.$message.error(res.error_message)
          return
        }
        if (res.error_code === '0') {
          this.handlerTime()
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 创建连锁门店
    async chainShopCreate () {
      if (!this.smsCode && !this.chainPhone) {
        this.$message.error('请输入手机号码和验证码')
        return
      }
      try {
        const res = await chainShopCreate({
          chainPhone: this.chainPhone,
          smsCode: this.smsCode,
          activeCode: this.activeCode
        })

        if (res.error_code !== '0') {
          this.$message.error(res.error_msg)
          return
        }
        this.shopId = res.data.shopId
        this.$emit('handlerSuccess', { shopId: res.data.shopId, mobile: this.chainPhone })
      } catch (e) {
        this.$message.error(e.error_msg)
      }
    },
    handlerTime () {
      this.flag = true
      const time = setInterval(() => {
        if (this.count > 1) {
          this.count--
          return
        }
        this.flag = false
        this.count = 60
        clearInterval(time)
      }, 1000)
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.block-btn{
  width:120px;
}
.block-title{
  margin:0 0 40px 0;
}
.block-wrap{
  width:600px;
  margin:120px auto;
}
.block-code-wrap{
  padding:20px 0 0 0;
  .label{
    padding:0 20px 0 0;
    width:100px;
    em{
      color: red;
      font-style: normal;
      padding:0 4px 0 0;
    }
  }
  .block-right{
    width:260px;
    // border:1px solid red;
  }
}
.block-next{
  margin:40px 0 0 0;
  .btn-next{
    width:240px;
  }
}
</style>
